import { render, staticRenderFns } from "./kindChooseViewsSeventh.vue?vue&type=template&id=cef6eca0&scoped=true"
import script from "./kindChooseViewsSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewsSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewsSeventh.vue?vue&type=style&index=0&id=cef6eca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef6eca0",
  null
  
)

export default component.exports